export enum ProfileSortByOption {
  NAMES = 'NAMES',
  ASSESSMENT_STATUS = 'ASSESSMENT_STATUS',
}
